//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import vFilter from "../util/filters";

  export default {
    name: "LoanDetail",
    data() {
      return {
        showDetail: true,
        loanDetail: {},
      };
    },
    filters: {
      formatMoney: vFilter.moneyFormat3,
    },
    created() {
      this.getDetail();
    },
    methods: {
      getDetail() {
        const _this = this;
        const projectId = this.$route.params.projectId || "";
        this.$axios({
          method: "post",
          url: "/wechat/queryMyLoansMsg.do",
          data: {
            projectId,
          },
        })
          .then((response) => {
            if (response.data.code === 200) {
              let detail = response.data.result[0];
              if (detail.PRINCIPALINTEREST < 0) {
                detail.PRINCIPALINTEREST = 0;
              }
              if (detail.PLANSUM < 0) {
                detail.PLANSUM = 0;
              }
              if (detail.PLANACCRUALSUM < 0) {
                detail.PLANACCRUALSUM = 0;
              }
              // 在还款日期的基础上增加3天，防止当天还款却显示逾期
              let nextPlanDate = new Date(detail.NEXTPLANDATE);
              nextPlanDate.setDate(nextPlanDate.getDate() + 3);
              detail.overDue =
                new Date(nextPlanDate).getTime() <
                new Date(vFilter.dateFormat(new Date())).getTime();
              _this.loanDetail = detail;
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      copyToClipboard(elementId) {
        // 获取元素
        const element = document.getElementById(elementId);
        // 检查是否成功获取到元素
        if (element) {
          const text = element.innerText;
          if (navigator.clipboard) {

            navigator.clipboard
              .writeText(text)
              .then(() => {
                // 成功复制后的操作，比如提示用户
                alert("已成功复制到剪贴板");
              })
              .catch((err) => {
                this.$refs.copyTextArea.value = text;
                // 选中textarea中的文本
                this.$refs.copyTextArea.select();
                // 执行复制命令
                document.execCommand('copy');
                alert("已成功复制到剪贴板!");
              });
          } else {
            this.$refs.copyTextArea.value = text;
            // 选中textarea中的文本
            this.$refs.copyTextArea.select();
            // 执行复制命令
            document.execCommand('copy');
            alert("已成功复制到剪贴板!");
          }
        } else {
          console.error("Element with ID", elementId, "not found");
        }
      },

      goBack() {
        this.$router.go(-1);
      },
    },
  };



// WEBPACK FOOTER //
// ./src/pages/LoanDetail.vue